<template>
    <div>
        <div
                v-on:click="toggleOpen(item)"
                class="p-3 border-t cursor-pointer hover:bg-blue-lighter"
                :style="padding"
        >
        <span class="pull-right">
            <i class="fa" :class="{
                'fa-chevron-down': !open,
                'fa-chevron-up': open
            }" ></i>
        </span>
            <i class="fa fa-fw"
               :class="{
                'fa-folder': !open && !loading,
                'fa-folder-open': open && !loading,
                'fa-circle-o-notch fa-spin': loading,
           }"
            ></i>
            {{ description }}
        </div>

        <div class="" v-if="open">
            <dsi-folder
                    v-for="item in sortFolders"
                    :key="item.id"
                    :item="item"
                    :search="search"
                    :depth="depth + 1"
            >
            </dsi-folder>

            <dsi-code
                    v-for="item in sortCodes"
                    :key="item.id"
                    :item="item"
                    :search="search"
                    :depth="depth + 1"
            >
            </dsi-code>
        </div>
    </div>
</template>

<script>

    export default {
        props: ['item', 'search', 'depth'],

        data: function () {
            return {
                item: this.item,
                loading: false,
            }
        },

        computed: {
            padding: function () {
                return 'padding-left:' + ((this.depth * 0.75) + 0.75) + 'rem';
            },
            description: function() {
                return this.item.translations.en;
            },
            sortFolders: function() {
                return _.sortBy(this.item.folders, 'translations.en');
            },
            sortCodes: function() {
                return _.sortBy(this.item.codes, 'translations.en');
            },
            open: function() {
                return this.item.codes.length > 0 || this.item.folders.length > 0;
            }
        },

        methods: {
            getChildren: function () {
                var that = this;

                that.loading = true;

                window.http
                    .get(that.item._links.self.href)
                    .then((response) => {
                        that.item.codes = response.data.codes;
                        that.item.folders = response.data.folders;
                        that.loading = false;
                    });
            },
            toggleOpen: function () {
                if (this.open) {
                    this.item.codes = [];
                    this.item.folders = [];
                } else {
                    this.getChildren();
                }
            }
        }
    }

</script>